import React, { Component } from "react";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { default as ReactSelect } from "react-select";

//components
import VerifyModal from "./VerifyModal";
import SecurityModal from "./SecurityModal";
import MobileLoginRegister from "./MobileLoginRegister";
import { mobilePrefix, mobilePrefixCodeAsKey } from "../../common/config/mobilePrefix";

//Miscellaneous
import Swal from "sweetalert2";
import { withRouter, Link } from "react-router-dom";
import { isDesktop } from "react-device-detect";
import { Icon } from "@iconify/react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { formValidation } from "../../hoc/Shared/utility";
import { getUserData } from "../../store/ducks/currentUser/actions";
import { postRegister, checkUsername, checkIpRegion, checkReferralRegion } from "../../store/ducks/register/actions";
import { postLogin } from "../../store/ducks/auth/actions";
import StringInput from "../../components/Input/StringInput/StringInput";
import PasswordInput from "../../components/Input/PasswordInput/PasswordInput";
import domain from "../../common/data/domain.json";
import { getCountry } from "../../store/ducks/home/actions";

let contact_no_min_limits = 9;
let contact_no_max_limits = 10;
let contactNoArry = [];

export class LoginRegister extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginPage: false,
            registerPage: false,
            showPwd: false,
            showLoginPwd: false,
            showPwdConfirmation: false,
            verifySuccess: false,
            username: "",
            password: "",
            loginUsername: "",
            loginPassword: "",
            confirm_password: "",
            refer_code: "",
            contact_no: "",
            contact_no_value: "", //"+60",
            contact_no_prefix: "", //"+60(Malaysia)",
            check_username: true,
            openVerifyModal: false,
            errorMsg: [],
            formError: false,

            visible: true,
            recaptcha_status: false,
            recaptcha_image_starting_point: Math.floor(Math.random() * 10) + 1,
            recaptcha_loading: false,

            openSecurityModal: false,
            // forgetPasswordModal: false,
            mobileVarificationCode: "",
            emailVarificationCode: "",
            
            mobile_selection_labelling: [],
            mobile_selection_shortcode: "",
            mobile_selection_prefix: "",
            mobile_selection_loading: true,
            ip_overwrite: false,
            ip_region_code: '',
        };
    }

    componentDidMount = () => {
        formValidation("member_register_form");
        formValidation("member_login_form");
        this.props.getCountry();
        
        // --- Handle referral code once at mount ---
        const urlParams = new URLSearchParams(window.location.search);
        const refCode = urlParams.get("refCode");
        const sessionReferralCode = sessionStorage.getItem("referralCode");

        if (refCode && refCode !== sessionReferralCode) {
            sessionStorage.setItem("referralCode", refCode);
            this.setState({ refer_code: refCode });
        } else if (sessionReferralCode) {
           this.setState({ refer_code: sessionReferralCode });
        }

        // clean up URL
        if (refCode) {
            urlParams.delete("refCode");
            const newParams = urlParams.toString();
            const newUrl = newParams
                ? `${window.location.pathname}?${newParams}`
                : window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);
        }
    };

    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;

        if (nextProps.country_data !== this.props.country_data) {
            this.props.checkIpRegion();

            let countryData = nextProps.country_data.country;
            
            contactNoArry = [];
            Object.keys(countryData).forEach((item, i) => {
                if (this.props.currentUser.data.country_code === countryData[item].countryShortCode) {
                    this.setState({
                        currentCountryId: countryData[item].countryId,
                        currentMobileDialCode: countryData[item].dialCode,
                    });
                }
                contactNoArry.push({
                    name: countryData[item].countryName,
                    value: countryData[item].dialCode,
                    image: countryData[item].countryShortCode + ".webp",
                    currency: countryData[item].currency,
                });
            });
        }

        if (nextProps.check_username_data !== this.props.check_username_data) {
            if (nextProps.check_username_data.data.message === "User Exist") {
                this.setState({
                    check_username: false,
                    errorMsg: nextProps.check_username_data.data.message,
                    formError: true,
                });
                document.getElementById("username").classList.remove("is-valid");
                document.getElementById("username").classList.add("is-invalid");
                // clearInputField("member_register_from");
            } else {
                document.getElementById("username").classList.remove("is-invalid");
                document.getElementById("username").classList.add("is-valid");
                this.setState({ check_username: true });
            }
        }

        if (nextProps.register_data !== this.props.register_data) {
            if (nextProps.register_data.responseCode === 200) {
                this.setState({ registerSuccess: true });
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    icon: "success",
                    title: t("global.success"),
                    text: nextProps.register_data.message,
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                            container: "swal-mobile-container sorry",
                            icon: "swal-sorry-icon",
                        }
                        : [],
                }).then((result) => {
                    if (result.isConfirmed) {
                        const data = {};
                        data.username = this.state.username;
                        data.password = this.state.password;

                        this.props.postLogin(data);
                    }
                });
            } else if (nextProps.register_data.responseCode === 422) {
                this.setState({
                    loading: false,
                    touched: true,
                    errorMsg: nextProps.register_data.message.input_error || [],
                    formError: true,
                });
                Swal.close();
            } else {
                this.setState({ loading: false });
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    title: t("global.sorry"),
                    text: nextProps.register_data.data.message[0],
                    // icon: nextProps.register_data.data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                            container: "swal-mobile-container sorry",
                            icon: "swal-sorry-icon",
                        }
                        : [],
                });
            }
        }

        if (nextProps.login_data !== this.props.login_data) {
            if (nextProps.login_data.responseCode === 200) {
                Swal.close();
                this.setState({ isLoading: false });

                sessionStorage.removeItem("telegram_user_info");
                sessionStorage.removeItem("google_user_info");

                let loginData = nextProps.login_data.data;

                const loggedData = {};
                loggedData.id = loginData.id;
                loggedData.username = loginData.username;
                loggedData.name = loginData.name;
                loggedData.user_group = loginData.user_group;
                loggedData.user_group_level = loginData.user_group_level;
                loggedData.country_id = loginData.country_id;
                loggedData.country_code = loginData.countryCode;
                loggedData.currency = loginData.currency;
                if (this.props.currentUser.data.country_id !== loginData.country_id) {
                    loggedData.language_id = loginData.languageID;
                    loggedData.language_code = loginData.languageCode;
                } else {
                    loggedData.language_id = this.props.currentUser.data.language_id;
                    loggedData.language_code = this.props.currentUser.data.language_code;
                }
                loggedData.member_group_id = loginData.group_id;
                loggedData.group_id = loginData.group_id;
                loggedData.contact_no = loginData.contact_no;
                loggedData.email = loginData.email;
                loggedData.balance = loginData.balance;
                loggedData.register_date_time = loginData.created_at;
                this.props.getUserData(loggedData);

                localStorage.setItem("accessToken", loginData.access_token);
                localStorage.setItem("username", loginData.username);

                if (this.props.currentUser.data.country_id !== loginData.country_id) {
                    let defaultLang = loginData.languageCode.replace("-", "_").toString().toLowerCase() || "en";
                    localStorage.setItem("lang", defaultLang);
                    this.props.i18n.changeLanguage(defaultLang); // force language change
                } else {
                    localStorage.setItem("lang", this.props.currentUser.data.language_code.replace("-", "_").toString().toLowerCase() || "en");
                }

                sessionStorage.removeItem("referralCode");  // clean referral

                // reset vip details page if diff country id
                localStorage.removeItem("vipDetails");

                this.props.history.push({
                    pathname: "/",
                    state: { showBackupUrlModal: true },
                });

                window.location.reload();

                this.setState({
                    username: "",
                    password: "",
                    openModal: false,
                });
            } else if (nextProps.login_data.responseCode === 422) {
                this.setState({
                    isLoading: false,
                    errorMsg: nextProps.login_data.message.input_error || [],
                    formError: true,
                });
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">' : "",
                    title: t("global.failed"),
                    text: nextProps.login_data.message,
                    // icon: nextProps.login_data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.confirm"),
                    customClass: !isDesktop
                        ? {
                            container: "swal-mobile-container failed",
                            icon: "swal-failed-icon",
                        }
                        : [],
                });
            }
        }

        if(nextProps.check_ip_region !== undefined && nextProps.check_ip_region !== this.props.check_ip_region){
            if(nextProps.check_ip_region.responseCode === 200){
                this.setState({
                    ip_overwrite: true,
                    ip_region_code: nextProps.check_ip_region.data.result
                });
            }
        }

        if (nextProps.check_referral_region !== undefined && nextProps.check_referral_region !== this.props.check_referral_region) {
            if (nextProps.check_referral_region.responseCode === 200) {
              if (nextProps.check_referral_region.data && nextProps.check_referral_region.data.result > 0 && mobilePrefix[nextProps.check_referral_region.data.result]) {
                this.setDefaultMobileCountryCode();               
              } else {
                Swal.fire({
                  iconHtml: !isDesktop
                    ? '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">'
                    : "",
                  title: t("global.failed"),
                  text: t("register.invalid-referral"),
                  icon: "error",
                  confirmButtonText: t("global.ok"),
                  customClass: !isDesktop
                    ? {
                      container: "swal-mobile-container failed",
                      icon: "swal-failed-icon",
                    }
                    : [],
                }).then((result) => {
                    sessionStorage.removeItem("referralCode");
                    this.setState({ refer_code: "" });
                    window.location.href = "/";
                });
              }
            }
        }

        return true;
    }

    lockMobileSelection = (referral_code) => {
        if (referral_code) {
            const data = {};
            data.refCode = referral_code;
            this.props.checkReferralRegion(data);
        } else {
            this.setDefaultMobileCountryCode();
        }
    };

    setDefaultMobileCountryCode = () => {
        let temp_ip_overwrite = this.state.ip_overwrite;
        let temp_ip_region_code = this.state.ip_region_code;
        let finalize_ip_overwrite = false;
        let contact_no_value = '';
        if(temp_ip_overwrite){
            if(temp_ip_region_code !== '' && mobilePrefixCodeAsKey[temp_ip_region_code]){
                finalize_ip_overwrite = true;
            }
        }
        
        if(finalize_ip_overwrite){
            contact_no_value = mobilePrefixCodeAsKey[temp_ip_region_code]["prefix"];
        
            this.setState({
                mobile_selection_labelling: mobilePrefixCodeAsKey[temp_ip_region_code]["tag"],
                mobile_selection_shortcode: mobilePrefixCodeAsKey[temp_ip_region_code]["code"],
                mobile_selection_prefix: mobilePrefixCodeAsKey[temp_ip_region_code]["prefix"],
                mobile_selection_loading: false,
            });
        }
        else{
          // default follow domain to set mobile country code
            contact_no_value = "+60";
            let temp_prefix = "+60";
            let temp_country = "Malaysia";
            let temp_image = "MY.webp";
            let temp_code = "MY";
        
            if (domain.id.key.includes(window.location.host)) { // override if indonesia
                contact_no_value = "+62";
                temp_prefix = "+62";
                temp_country = "Indonesia";
                temp_image = "ID.webp";
                temp_code = "ID";
            }
        
            this.setState({
                mobile_selection_labelling: [
                {
                    value: temp_prefix, //"+60",
                    name: temp_country, //"Malaysia",
                    image: temp_image, //"MY.webp",
                    phone: temp_prefix, //"+60",
                    code: temp_code //"MY",
                },
                ],
                mobile_selection_shortcode: temp_code, //"MY",
                mobile_selection_prefix: temp_prefix, //"+60",
                mobile_selection_loading: false,
                contact_no_value,
            });
        }
    };

    toggleLoginPage = () => {
        this.setState({
            loginPage: true,
            registerPage: false,
        });
    };

    toggleRegisterPage = () => {
        this.setState({
            loginPage: false,
            registerPage: true,
        }, () => {
            const referralCode = this.state.refer_code || sessionStorage.getItem("referralCode");
            if (referralCode) {
                this.lockMobileSelection(referralCode);
            }
        });
    };

    toggleSecurityModal = () => {
        this.setState({
            openSecurityModal: !this.state.openSecurityModal,
        });
    };

    toggleVerifyModal = () => {
        this.setState({
            openVerifyModal: !this.state.openVerifyModal,
        });
    };

    toggleShowPwd = () => {
        this.setState({
            showPwd: !this.state.showPwd,
        });
    };

    toggleShowConfirmPwd = () => {
        this.setState({
            showPwdConfirmation: !this.state.showPwdConfirmation,
        });
    };

    imageImport = (r) => {
        let images = {};
        r.keys().map((item) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    toggleShowLoginPwd = () => {
        this.setState({
            showLoginPwd: !this.state.showLoginPwd,
        });
    };

    onInputChange = (event) => {
        let value = event.target.value;
        if (event.target.id === "tnc_check") {
            value = event.target.checked;
        } else {
            value = event.target.value;
        }
    
        if (event.target.id === "contact_no") {
            if (event.target.value === "0") {
                value = "";
            }
        }
    
        if (event.target.id === "pwdConfirmation") {
            if (event.target.value !== this.state.pwd) {
                document.getElementById("pwdConfirmation").classList.remove("is-valid");
                document.getElementById("pwdConfirmation").classList.add("is-invalid");
            } else {
                document
                .getElementById("pwdConfirmation")
                .classList.remove("is-invalid");
            }
        }
    
        this.setState({
            [event.target.id]: value,
        });
    };

    postMemberRegister = (e) => {
        e.preventDefault();
        const { t } = this.props;

        let currency = '';
        contactNoArry.map((item) => {
            if(item.value === this.state.contact_no_value)
            {
                currency = item.currency;
            }
        });

        let currencyNotification = t("register.currency-notification").replace("##currency##", currency);
        currencyNotification += t("global.would-you-like-to-proceed") + "?";

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.confirmation"),
            text: t("global.would-you-like-to-proceed") + "?",
            html: currencyNotification,
            icon: "warning",
            confirmButtonText: t("global.ok"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                    container: "swal-mobile-container confirmation",
                    icon: "swal-confirmation-icon",
                }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading();
                    },
                });

                let data = {};
                data.username = this.state.username;
                data.password = this.state.password;
                data.confirm_password = this.state.confirm_password;

                if (this.state.contact_no_prefix.value === undefined || "" ||null) {
                    data.contact_number = this.state.contact_no_value.replace(/^\+/, "") + this.state.contact_no.replace(/ /g, "");
                    data.contact_prefix = this.state.contact_no_value;
                }
        
                if (this.state.contact_no !== "" && (this.state.contact_no_prefix.value !== undefined || "" || null)) {
                    data.contact_number = this.state.contact_no_prefix.value.replace(/^\+/, "") + this.state.contact_no.replace(/ /g, "");
                    data.contact_prefix = this.state.contact_no_prefix.value;
                }

                if (this.state.refer_code !== "" && this.state.refer_code !== null) {
                    data.refer_code = this.state.refer_code;
                }

                if (localStorage.getItem("lang")) {
                    data.language_code = localStorage.getItem("lang");
                }
                // console.log(data);
                this.props.postRegister(data);
            }
        });
    };

    postMemberLogin = (e) => {
        e.preventDefault();
        const { t } = this.props;

        if (this.state.recaptcha_status === false) {
            Swal.fire({
                iconHtml: !isDesktop
                    ? '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">'
                    : "",
                title: t("global.failed"),
                text: t("global.please-completed-recaptcha"),
                icon: "error",
                confirmButtonText: t("global.ok"),
                customClass: !isDesktop
                    ? {
                        container: "swal-mobile-container failed",
                        icon: "swal-failed-icon",
                    }
                    : [],
            }).then(() => {
                if (!this.state.openSecurityModal) {
                    this.toggleSecurityModal();
                }
            });
            return false;
        } else {
            let data = {};
            data.username = this.state.loginUsername;
            data.password = this.state.loginPassword;

            this.props.postLogin(data);
        }

    };

    handleUsername = (e) => {
        this.setState({
            username: e.target.value,
            check_username: true,
        });
    };

    handleLoginUsername = (e) => {
        this.setState({
            loginUsername: e.target.value,
        });
    };

    handlePassword = (e) => {
        this.setState({
            password: e.target.value,
        });
    };

    handleLoginPassword = (e) => {
        this.setState({
            loginPassword: e.target.value,
        });
    };

    handleConfirmPassword = (e) => {
        this.setState({
            confirm_password: e.target.value,
        });
    };

    handleReferCode = (e) => {
        this.setState({
            refer_code: e.target.value,
        });
    };

    handleCheckUsername = () => {
        if (this.state.username !== "") {
            const data = {};
            data.username = this.state.username;
            this.props.checkUsername(data);
        }
    };

    handleCountryContactNo = (event) => {
        switch (event.value) {
            case "+60":
                contact_no_min_limits = 9;
                contact_no_max_limits = 10;
                break;
            case "+66":
                contact_no_min_limits = 8;
                contact_no_max_limits = 8;
                break;
            case "+62":
                contact_no_min_limits = 11;
                contact_no_max_limits = 14;
                break;
            case "+84":
                contact_no_min_limits = 9;
                contact_no_max_limits = 9;
                break;
            case "+1":
                contact_no_min_limits = 10;
                contact_no_max_limits = 10;
            break;
            default:
            break;
        }

        this.setState({
            contact_no_value: event.value,
            formError: false,
            errorMsg: [],
        });
    }

    recaptchaSuccess = (status) => {
        // alert(status);
        if (status === undefined) {
            // reload recaptcha
            this.setState(
                {
                    visible: false,
                    recaptcha_image_starting_point:
                        this.state.recaptcha_image_starting_point < 10
                            ? this.state.recaptcha_image_starting_point + 1
                            : 1,
                },
                () => {
                    this.setState({ visible: true });
                }
            );
        }
        if (status) {
            const { t } = this.props;

            Swal.fire({
                iconHtml: !isDesktop
                    ? status === "success"
                        ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">'
                        : '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">'
                    : "",
                title: t(`global.${status}`),
                text:
                    status === "success"
                        ? t("global.completed-recaptcha")
                        : t("global.please-completed-recaptcha"),
                icon: status === "success" ? "success" : "error",
                confirmButtonText: t("global.confirm"),
                customClass: !isDesktop
                    ? {
                        container:
                            status === "success"
                                ? "swal-mobile-container sucess"
                                : "swal-mobile-container failed",
                        icon:
                            status === "success" ? "swal-success-icon" : "swal-failed-icon",
                    }
                    : [],
            });
            if (status === "success") {
                this.setState({
                    visible: false,
                    recaptcha_status: true,
                    verifySuccess: true,
                    openSecurityModal: false,
                });
            } else {
                // on failed
                this.setState(
                    {
                        recaptcha_loading: true,
                        recaptcha_image_starting_point:
                            this.state.recaptcha_image_starting_point < 10
                                ? this.state.recaptcha_image_starting_point + 1
                                : 1,
                    },
                    () => {
                        this.setState({ recaptcha_loading: false });
                    }
                );
            }
        }
    };

    render() {
        const logo = this.imageImport(require.context("../../assets/images/", false, /\.(png|jpe?g|svg|webp)$/));
        const icon = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));
        const flag = this.imageImport(require.context("../../assets/images/flags/", false, /\.(png|jpe?g|svg|webp)$/));
        const { t } = this.props;

        let formSubmit = false;

        if (
            this.state.username !== "" &&
            this.state.password !== "" &&
            this.state.confirm_password !== "" &&
            this.state.password === this.state.confirm_password &&
            this.state.check_username === true && 
            this.state.contact_no_value !== "" && 
            this.state.contact_no !== "" 
        ) {
            formSubmit = true;
        }

        let imageLanguage = '';
        switch (this.props.currentUser.data.language_code) {
            case "zh-CN":
                imageLanguage = "-cn"
                break;
            // case "ms":
            //     imageLanguage = "-ms"
            //     break;
            default:
                imageLanguage = ""
                break;
        }

        contactNoArry.map((item, value) => {
            return (item.label = item.value + "(" + t("register.dial-code-available." + item.value) + ")");
        });

        return (
            <Auxiliary>
                <VerifyModal {...this.state} {...this.props} toggleVerifyModal={this.toggleVerifyModal} />
                <SecurityModal
                    {...this.state}
                    {...this.props}
                    toggleSecurityModal={this.toggleSecurityModal}
                    recaptchaSuccess={this.recaptchaSuccess}
                />
                {isDesktop ? (
                    <section className="logreg-wrap">
                        {/* <div className="logreg-logo">
                            <img src={logo["x33-logo.png"]} alt="logo" />
                        </div> */}

                        <div className="row">
                            <div className="col-6">
                                <img className="left-img" src={icon["img_affliate_bg_1.webp"]} alt="logo" />
                            </div>
                            <div className="col-6">
                                {this.state.loginPage === true ? (
                                    <>
                                        <div className="header-wrap">
                                            <img className="title-img" src={icon[`login-title${imageLanguage}.webp`]} alt="title img" />
                                        </div>
                                        <div className="btn-wrap">
                                            <button className={`btn btn-white ${this.state.loginPage === true && "active"}`} onClick={this.toggleLoginPage}>
                                                <p>{t("page-header.login")}</p>
                                            </button>
                                            <button className={`btn btn-white ${this.state.registerPage === true && "active"}`} onClick={this.toggleRegisterPage}>
                                                <p>{t("page-header.register")}</p>
                                            </button>
                                        </div>
                                        <div className="logreg-body-wrap">
                                            <form
                                                className="forms-col needs-validation"
                                                noValidate
                                                method="post"
                                                id="member_login_form"
                                                name="member_login_form"
                                                onSubmit={this.postMemberLogin}
                                            >
                                                <div className="input-group left has-validation">
                                                    <span className="input-group-text left-icon">
                                                        <img src={icon["icon-user.png"]} alt="username icon" />
                                                    </span>
                                                    <StringInput
                                                        className={`form-control ${this.state.errorMsg.loginUsername && "was-validated is-invalid"}`}
                                                        id="loginUsername"
                                                        placeholder={t("register.account")}
                                                        type="text"
                                                        required
                                                        requiredMessage={t("validation.required")}
                                                        autoComplete="off"
                                                        onChange={this.handleLoginUsername}
                                                        value={this.state.loginUsername}
                                                        errorMsg={this.state.errorMsg.loginUsername || ""}
                                                        formError={this.state.formError}
                                                    />
                                                </div>
                                                <div className="input-group left has-validation">
                                                    <span className="input-group-text left-icon">
                                                        <img src={icon["icon-password.png"]} alt="username icon" />
                                                    </span>
                                                    <PasswordInput
                                                        showPwd={this.state.showLoginPwd}
                                                        className={`form-control no-border-r ${this.state.errorMsg.loginPassword && "was-validated is-invalid "}`}
                                                        id="loginPassword"
                                                        autoComplete="off"
                                                        placeholder={t("register.enter-password")}
                                                        onChange={this.handleLoginPassword}
                                                        required
                                                        requiredMessage={t("validation.required")}
                                                        value={this.state.loginPassword}
                                                        errorMsg={this.state.errorMsg.loginPassword || ""}
                                                        formError={this.state.formError}
                                                        format={
                                                            <button type="button" className=" right-icon" onClick={this.toggleShowLoginPwd}>
                                                                {this.state.showLoginPwd ? (
                                                                    <img src={icon["eye.png"]} alt="show pwd" />
                                                                ) : (
                                                                    <img src={icon["close-eye.png"]} alt="hide pwd" />
                                                                )}
                                                            </button>
                                                        }
                                                    />
                                                </div>
                                                <div>
                                                    <button
                                                        type="button"
                                                        className={`btn btn-outline-blue rounded-pill w-100 text-start ${this.state.verifySuccess === true && "success disabled"}`}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            this.toggleSecurityModal();
                                                        }}
                                                    >
                                                        <span className="left-icon">
                                                            {!this.state.verifySuccess ? (
                                                                <img src={icon["icon-shield.png"]} alt="shield icon" />
                                                            ) : (
                                                                <img src={icon["shield_2.png"]} alt="username icon" />
                                                            )}
                                                        </span>
                                                        {t("sign-in.verify")}
                                                    </button>
                                                    <div className="d-flex justify-content-between small-w mt-2">
                                                        <div className="checklist">
                                                        </div>
                                                        <button className="btn btn-wo-border " type="button">
                                                            <Link to={{ pathname: "/forget-password" }}>
                                                                <small>{t("sign-in.forget-password")}</small>
                                                            </Link>
                                                        </button>
                                                    </div>
                                                </div>

                                                <button
                                                    className={`btn btn-gradient-blue rounded-pill ${this.state.loginUsername !== "" && this.state.loginPassword !== "" ? `` : `disabled`
                                                        }`}
                                                    type="submit"
                                                    form="member_login_form"
                                                >
                                                    {t("sign-in.title")}
                                                </button>
                                            </form>
                                        </div>
                                    </>
                                ) : this.state.registerPage === true ? (
                                    <>
                                        <div className="header-wrap">
                                            <img className="title-img" src={icon[`login-title${imageLanguage}.webp`]} alt="title img" />
                                        </div>
                                        <div className="btn-wrap">
                                            <button className={`btn btn-white ${this.state.loginPage === true && "active"}`} onClick={this.toggleLoginPage}>
                                                <p>{t("page-header.login")}</p>
                                            </button>
                                            <button className={`btn btn-white ${this.state.registerPage === true && "active"}`} onClick={this.toggleRegisterPage}>
                                                <p>{t("page-header.register")}</p>
                                            </button>
                                        </div>
                                        <div className="logreg-body-wrap">
                                            <form
                                                className="forms-col needs-validation"
                                                noValidate
                                                method="post"
                                                id="member_register_form"
                                                name="member_register_form"
                                                onSubmit={this.postMemberRegister}
                                            >
                                                <div className="input-group left has-validation">
                                                    <span className="input-group-text left-icon">
                                                        <img src={icon["icon-user.png"]} alt="username icon" />
                                                    </span>
                                                    <StringInput
                                                        className={`form-control w-border-r ${this.state.errorMsg.username && "was-validated is-invalid"}`}
                                                        id="username"
                                                        placeholder={t("register.account")}
                                                        type="text"
                                                        required
                                                        requiredMessage={t("validation.required")}
                                                        autoComplete="off"
                                                        onChange={this.handleUsername}
                                                        onBlur={this.handleCheckUsername}
                                                        value={this.state.username}
                                                        errorMsg={this.state.errorMsg.username || ""}
                                                        formError={this.state.formError}
                                                    />

                                                    {this.state.check_username === false ? (
                                                        <div className="invalid-feedback">
                                                            <Icon icon="akar-icons:circle-alert-fill" />
                                                            {t("register.username-name-exist")}
                                                        </div>
                                                    ) : (
                                                        <span className="valid-feedback">
                                                            <Icon icon="akar-icons:circle-check-fill" />
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="input-group left has-validation">
                                                    <span className="input-group-text left-icon">
                                                        <img src={icon["icon-password.png"]} alt="username icon" />
                                                    </span>
                                                    <PasswordInput
                                                        showPwd={this.state.showPwd}
                                                        className={`form-control no-border-r ${this.state.errorMsg.password && "was-validated is-invalid "}`}
                                                        id="password"
                                                        autoComplete="off"
                                                        placeholder={t("register.enter-password")}
                                                        onChange={this.handlePassword}
                                                        required
                                                        requiredMessage={t("validation.required")}
                                                        value={this.state.password}
                                                        errorMsg={this.state.errorMsg.password || ""}
                                                        formError={this.state.formError}
                                                        format={
                                                            <button type="button" className=" right-icon" onClick={this.toggleShowPwd}>
                                                                {this.state.showPwd ? <img src={icon["eye.png"]} alt="show pwd" /> : <img src={icon["close-eye.png"]} alt="hide pwd" />}
                                                            </button>
                                                        }
                                                    />
                                                </div>
                                                <div className="input-group left has-validation">
                                                    <span className="input-group-text left-icon">
                                                        <img src={icon["icon-password.png"]} alt="username icon" />
                                                    </span>
                                                    <PasswordInput
                                                        showPwdConfirmation={this.state.showPwdConfirmation}
                                                        className={`form-control no-border-r ${this.state.errorMsg.confirm_password && "was-validated is-invalid "}`}
                                                        id="confirm_password"
                                                        autoComplete="off"
                                                        placeholder={t("register.reenter-password")}
                                                        required
                                                        requiredMessage={t("validation.required")}
                                                        value={this.state.confirm_password}
                                                        oldPassword={this.state.password}
                                                        confirmpassword={this.state.confirm_password}
                                                        onChange={this.handleConfirmPassword}
                                                        format={
                                                            <button type="button" className=" right-icon" onClick={this.toggleShowConfirmPwd}>
                                                                {this.state.showPwdConfirmation ? (
                                                                    <img src={icon["eye.png"]} alt="show pwd" />
                                                                ) : (
                                                                    <img src={icon["close-eye.png"]} alt="hide pwd" />
                                                                )}
                                                            </button>
                                                        }
                                                    />
                                                </div>
                                                <div className="input-group left has-validation">
                                                    <ReactSelect
                                                        classNamePrefix="react-select"
                                                        defaultValue={this.state.mobile_selection_labelling.filter(
                                                            (country) =>
                                                                country.code ===
                                                                this.state.mobile_selection_shortcode
                                                        )}
                                                        options={contactNoArry}
                                                        onChange={this.handleCountryContactNo}
                                                        formatOptionLabel={(item) => (
                                                            <>
                                                                <img src={flag[`${item.image}`]} alt={item.image} />
                                                                <p>{item.value}</p>
                                                                <p>{item.name}</p>
                                                            </>
                                                        )}
                                                    />
                                                    <StringInput
                                                        className={`${this.state.errorMsg.contact_number &&
                                                            "was-validated is-invalid"
                                                            }`}
                                                        onChange={this.onInputChange}
                                                        name="contact_no"
                                                        id="contact_no"
                                                        placeholder="123456789"
                                                        value={this.state.contact_no}
                                                        minLength={contact_no_min_limits}
                                                        maxLength={contact_no_max_limits}
                                                        minLengthMessage={
                                                            this.state.errorMsg.contact_number
                                                            ? ""
                                                            : t("validation.minLength", {
                                                                0: contact_no_min_limits,
                                                            })
                                                        }
                                                        maxLengthMessage={
                                                            this.state.errorMsg.contact_number
                                                            ? ""
                                                            : t("validation.maxLength", {
                                                                0: contact_no_max_limits,
                                                            })
                                                        }
                                                        required
                                                        requiredMessage={t("validation.required")}
                                                        errorMsg={this.state.errorMsg.contact_number || ""}
                                                        formError={this.state.formError}
                                                    />
                                                </div>
                                                <div className="text-center ">
                                                    <button
                                                        className={`btn btn-gradient-blue rounded-pill w-100  ${formSubmit === false ? `disabled` : ``}`}
                                                        type="submit"
                                                        form="member_register_form"
                                                    >
                                                        {t("page-header.register")}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="header-wrap">
                                            <img className="title-img" src={icon[`login-title${imageLanguage}.webp`]} alt="title img" />
                                        </div>
                                        <div className="btn-wrap">
                                            <button className={`btn btn-white ${this.state.loginPage === true && "active"}`} onClick={this.toggleLoginPage}>
                                                <p>{t("page-header.login")}</p>
                                            </button>
                                            <button className={`btn btn-white ${this.state.registerPage === true && "active"}`} onClick={this.toggleRegisterPage}>
                                                <p>{t("page-header.register")}</p>
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </section>
                ) : (
                    <>
                        <MobileLoginRegister
                            {...this.state}
                            {...this.props}
                            toggleLoginPage={this.toggleLoginPage}
                            toggleRegisterPage={this.toggleRegisterPage}
                            toggleShowConfirmPwd={this.toggleShowConfirmPwd}
                            toggleShowPwd={this.toggleShowPwd}
                            handlePassword={this.handlePassword}
                            handleConfirmPassword={this.handleConfirmPassword}
                            handleUsername={this.handleUsername}
                            handleCheckUsername={this.handleCheckUsername}
                            postMemberLogin={this.postMemberLogin}
                            postMemberRegister={this.postMemberRegister}
                            handleLoginPassword={this.handleLoginPassword}
                            handleLoginUsername={this.handleLoginUsername}
                            toggleSecurityModal={this.toggleSecurityModal}
                            handleReferCode={this.handleReferCode}
                            onInputChange={this.onInputChange}
                            toggleShowLoginPwd={this.toggleShowLoginPwd}
                            handleCountryContactNo={this.handleCountryContactNo}
                            mobileSelectionLabelling={this.state.mobile_selection_labelling}
                            mobileSelectionPrefix={this.state.mobile_selection_prefix}
                            mobileSelectionShortcode={this.state.mobile_selection_shortcode}
                            contactNoArry={contactNoArry}
                            defaultMobileMaxLimit={contact_no_max_limits}
                            defaultMobileMinLimit={contact_no_min_limits}
                        />

                    </>
                )}
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    const { home, register, auth } = state;
    
    return {
        register_data: register.register_data,
        country_data: home.country_data,
        currentUser: state.currentUser,
        check_username_data: register.check_username_data,
        login_data: auth.login_data,
        check_ip_region: register.check_ip_region,
        check_referral_region: register.check_referral_region
    };
};

const mapDispatchToProps = {
    postRegister,
    checkUsername,
    postLogin,
    getUserData,
    checkIpRegion,
    getCountry,
    checkReferralRegion
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withNamespaces("translation")(LoginRegister)));
